import defaultTagData from './default';
import eventTagData from './event';
import hotissueTagData from './hotissue';
import liveTagData from './live';
import live24tvTagData from './live24tv';
import passTagData from './pass';
import playzoneTagData from './playzone';
import tvTagData from './tv';
import sbsplayon from './sbsplayon';
import { isVirtualChannel, parseUrlPath } from '../../utils/liveUtil';

export default function index(urlPath, pageSection = '', pageCategory = '') {
  const firstSegment = (urlPath || '')
    .split('?')[0]
    .split('/')
    .filter((x) => x !== 'm' && !!x)[0];
  let result;

  switch (firstSegment) {
    case 'tv':
      result = tvTagData(pageSection);
      break;
    case 'live':
      console.log('urlPath', urlPath);
      const { channelId, type } = parseUrlPath(urlPath);
      console.log('channelId', channelId);
      console.log('type', type);

      if (type === '24tv' || isVirtualChannel(channelId)) {
        result = live24tvTagData(pageSection);
      } else {
        result = liveTagData(pageSection);
      }
      break;
    case 'event':
    case 'promotion':
      result = eventTagData;
      break;
    case 'hotissue':
      result = hotissueTagData;
      break;
    case 'pass':
      result = passTagData(pageSection);
      break;
    case 'playzone':
      result = playzoneTagData(pageSection);
      break;
    case 'sbsplayon':
      result = sbsplayon;
      break;
    default:
      result = defaultTagData;
      break;
  }

  return { ...result };
}
